/** @jsx jsx */
import React, { Component } from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';

import DetailITinfraOracleLogoImg from './DetailsITinfraSolutionOracleLogo.png';
import DetailITinfraCloudImg from './DetailsITinfraSolutionCloud.png';
import DetailEpsonHistoryImg from "../EpsonCR/DetailsEpsonCRHistory.png";

const Section = styled.section`
  border: 0px solid #dadce0;

  color: #363a3c;
  
  font-family: 'Malgun Gothic';
  font-family: 'Noto Sans KR', sans-serif;
  font-family: 'Spoqa Han Sans', 'Spoqa Han Sans JP', 'Sans-serif';
`;
const SubSection = styled.div`
  margin-bottom: 50px;
`;
const ContainerFluid = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: 16px 24px;

  box-sizing: border-box;
  max-width: 1140px;
`;
const HighlightText = styled.h1`
  margin-top: 0;
  margin-bottom: 0;
  word-break: break-all;
  font-size: 20px;
  line-height: 1.6;
  
  box-sizing: border-box;
`;
const CssHeaderText100 = css`
  font-weight: 100;
`;
const CssHeaderText300 = css`
  font-weight: 300;
`;
const CssHeaderText400 = css`
  font-weight: 400;
`;

const DivFlexboxWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
const DivFlexItem = styled.div`
  border: 0px solid #dadce0;
  box-sizing: border-box;
  width: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0px;
`;
const DivFlexboxNoWrap = styled.div`
  display: flex;
  justify-content: center;
`;
const DivFlexItemNoWrap = styled.div`
  border: 0px solid #dadce0;
  box-sizing: border-box;
  padding-top: 20px;
`;
const ImgFlexItemNoWrap = styled.img`
  width: 100%;
`;

const SpanAbsoluteBold = styled.span`
  position: absolute;
  font-weight: 700;
`;
const DivIndent20 = styled.div`
  margin-left: 20px;
`;

class DetailsITinfraSolution extends Component {
  render() {
    return (
      <div className="DetailsITinfraSolution">

        <Section className="section">
          <ContainerFluid className="container-fluid">

            <SubSection className="Intro">
              <p className="header-text-300" css={CssHeaderText300}>봄시스템즈는 기업고객별 고유의 니즈(Needs)를 반영한 IT 인프라 컨설팅, 개발, 기술지원, 유지보수 등을 제공하고 있습니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>고객의 비즈니스 전략을 고려하여 Oracle SW & HW 공급, 유지보수 및 기술지원 등 제반 서비스를 공급하고 있습니다. 또한, 다년간의 체계적인 Project 수행 경험을 바탕으로 ORACLE Solution 서비스, 컨설팅 사업도 진행하고 있습니다.</p>
              <p className="header-text-300" css={CssHeaderText300}>이밖에 Global Vendor의 Cloud Solution 공급과 연계하여, 고객사의 기존 Infra SW를 Cloud 환경으로 전환하여 대체하는 서비스도 준비 중에 있습니다.</p>

              <DivFlexboxNoWrap className="DivFlexboxNoWrap">
                <DivFlexItemNoWrap><ImgFlexItemNoWrap src={DetailITinfraOracleLogoImg}/></DivFlexItemNoWrap>
              </DivFlexboxNoWrap>
              <DivFlexboxNoWrap className="DivFlexboxNoWrap">
                <DivFlexItemNoWrap><ImgFlexItemNoWrap src={DetailITinfraCloudImg}/></DivFlexItemNoWrap>
              </DivFlexboxNoWrap>
            </SubSection>

          </ContainerFluid>
        </Section>

      </div>
    );
  }
}

export default DetailsITinfraSolution;
